import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosConfig";

export const findFormsSubmitted = createAsyncThunk(
  "locationShow/findFormsSubmitted",
  async (idLocation: string, { rejectWithValue, getState }) => {
    try {
      const {
        data: [formSubmitted],
      } = await axiosInstance.get(`${api.baseURL}formsubmitted`, {
        params: {
          where: { location: idLocation },
          limit: 1,
        },
      });

      if (!formSubmitted) throw new Error("No tiene formulario asignado");

      const { data: answers } = await axiosInstance.get(`${api.baseURL}formanswer`, {
        params: {
          where: { form: formSubmitted.id },
        },
      });

      return {
        ...formSubmitted,
        answers,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
